import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {HttpErrorResponse, HttpStatusCode} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class OrderHistoryProcessingErrorService {
  private readonly orderHistoryProcessingError = new Subject<boolean>();
  public orderHistoryProcessingError$ = this.orderHistoryProcessingError.asObservable();

  shouldHandleError(error: HttpErrorResponse) {
    return error.status === HttpStatusCode.Conflict;
  }

  showError() {
    this.orderHistoryProcessingError.next(true);
  }
}
